import { Module, VuexModule, Mutation, Action, getModule } from 'vuex-module-decorators'
import { store } from '../../store'
import { appSettingsApi } from '../../services/api/app-settings.api'
import { AppSetting } from '../../models/app-setting'

@Module({
    dynamic: true,
    namespaced: true,
    name: 'app-settings',
    store,
})
class AppSettingsStore extends VuexModule {
    private settings: AppSetting[] | null = null

    get appSettings() {
        return this.settings
    }

    get isDirectSales() {
        if (this.settings === null) {
            return false
        }

        const directSales = this.settings.find(x => x.key === 'subscriptions/direct_sales')
        if (directSales === undefined) {
            return false
        }

        return directSales.value.IsTruthy()
    }

    @Mutation
    setAppSettings(settings: AppSetting[]) {
        this.settings = settings
    }

    @Action({ rawError: true })
    async init() {
        const settings = await appSettingsApi.getAll()
        this.setAppSettings(settings)
    }

    @Action({ rawError: true })
    getSetting(settingKey: string) {
        if (this.settings === null) {
            return ''
        }
        const setting = this.settings.find(x => x.key === settingKey)
        if (setting === undefined) {
            return ''
        }
        return setting.value
    }
}

export const appSettingsStore = getModule(AppSettingsStore)
